import React from 'react';
import { useTranslation } from 'react-i18next';
import { TimePeriod } from '@keen.io/ui-core';
import { parseCustomInterval } from './utils/parseCustomInterval';
import { Container } from './CustomInterval.styles';
import { EVERY } from './constants';

var CustomInterval = function CustomInterval(_ref) {
  var interval = _ref.interval,
      _onChange = _ref.onChange;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _parseCustomInterval = parseCustomInterval(interval),
      value = _parseCustomInterval.value,
      timeUnit = _parseCustomInterval.timeUnit;

  return React.createElement(Container, {
    "data-testid": "custom-interval"
  }, React.createElement(TimePeriod, {
    label: t('custom_interval.main_label'),
    unitsPlaceholder: t('custom_interval.unit_placeholcer'),
    relativity: EVERY,
    value: value,
    units: timeUnit,
    onChange: function onChange(timeframe) {
      return _onChange(timeframe);
    }
  }));
};

export default CustomInterval;